module.exports = { 
    URL: 'https://acidicterminal.vercel.app' || 'http://localhost:5000'
};